<template>
  <div class="student_report_shengya">
    <div class="circle_name">
      <span></span>推荐{{type}}
    </div>
     <div class="zyzytj">
       <div class="tjlist">
         <div class="tjtop">
           职业领域
         </div>
         <div class="tjbottoms">
           通过对您的人格特性、兴趣倾向、一般认知潜能的三方面综合分析，您最适合从事<span>{{cdata.name}}</span>领域的工作。
         </div>
       </div>
       <div class="tjlist">
         <div class="tjtop">典型职业</div>
         <div class="tjbottom">
           <div v-for="(item,index) in cdata.careers||[]" :key="index">
             <span></span>{{item.name}}
           </div>
         </div>
       </div>
       <div class="tjlist">
         <div class="tjtop">
           推荐专业及专业代码
         </div>
         <div class="tjbottom">
           <div v-for="(item,index) in cdata.majors||[]" :key="index">
             <span></span>{{item.name}}  {{item.code}}
           </div>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
export default {
  name: "rgtx",
  props:['reportId','type'],
  data(){
    return {
      cdata:{},
      updata:true
    }
  },
  methods:{
    getData(){
      this.$ajax.post(this.G_report + this.ports.consultant.student.report.zylx,{
        report_id:this.reportId
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==0){
          if(this.type=='1'){
            this.cdata=res.data.result.ctype.best;
            this.$emit('event',{
              best:res.data.result.ctype.best,
              second:res.data.result.ctype.second,
              third:res.data.result.ctype.third
            })
          }
          if(this.type=='2'){
            this.cdata=res.data.result.ctype.second;
          }
          if(this.type=='3'){
            this.cdata=res.data.result.ctype.third;
          }

        }else{
        }
      })
    }
  },
  mounted() {
    this.getData()
  },
}
</script>
<style lang="less" scoped>
    @import '../../css/evaluationReport.less';
    .circle_name{
      font-size: 14px;
      display: flex;
      align-items: center;
      line-height: 24px;
      span{
        width: 12px;
        height: 12px;
        background: #00A2FF;
        border: 2px solid #D4F0FF;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
</style>